/**
 * Fetches invoices for a given user and updates the state with the fetched invoices.
 * @function
 * @async
 *
 * @param {Object} params - The parameters for the function.
 * @param {Function} params.dispatchAPI - The function to dispatch API calls.
 * @param {Object} params.user - The user object containing user details.
 * @param {Function} params.setInvoices - The function to update the state with the fetched invoices.
 * @param {Function} params.message - The function to display error messages.
 * @returns {Promise<void>} - A promise that resolves when the invoices are fetched and state is updated.
 */

const getDocumentUseCase = (invoice) => {
  const { type, status } = invoice;

  if (type === 'SUBSCRIPTION') {
    const normalizedStatus = status === 'FREE' ? 'PAID' : status;
    return `SUBSCRIPTION_INVOICE_${normalizedStatus}`;
  }

  if (type === 'BALANCE') {
    return `OWNER_INVOICE_${status}`;
  }

  if (type === 'ADVANCE_PAYMENT') {
    return `OWNER_ADVANCE_INVOICE_${status}`;
  }

  return invoice.type?.replaceAll('-', '_');
};

export const getInvoices = async ({
  dispatchAPI,
  user,
  setInvoices,
  message
}) => {
  try {
    const { data } = await dispatchAPI('GET', {
      url: `customerinvoices?customer=${user._id}&populate=supervision,subscription`
    });

    const updatedInvoices = data.length
      ? data.map((invoice) => ({
          ...invoice,
          document_type: getDocumentUseCase(invoice)
        }))
      : [];

    setInvoices(updatedInvoices);
  } catch (e) {
    message(e);
  }
};
